'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Spinner = require('./Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingContent = function LoadingContent(props) {
  return props.isLoading ? _react2.default.createElement(_Spinner2.default, { size: props.size }) : _react2.default.createElement(
    'div',
    null,
    props.children
  );
};

LoadingContent.defaultProps = {
  isLoading: true,
  size: 'large'
};

LoadingContent.propTypes = {
  isLoading: _react2.default.PropTypes.bool,
  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.element, _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.element)]).isRequired,
  size: _react2.default.PropTypes.oneOf(['large', 'medium', 'small'])
};

exports.default = LoadingContent;


//////////////////
// WEBPACK FOOTER
// ./~/@myob/myob-widgets/lib/components/spinner/LoadingContent.js
// module id = 255
// module chunks = 0